import React from 'react'
import { connect } from 'react-redux'
import View from '../components/View'

class Error extends React.Component {

	render() {
		return <View {...this.props} />
	}
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {

	return {
		isLogged: state.auth.token
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Error)



// WEBPACK FOOTER //
// ./src/routes/Error/containers/Error.js